<template>
  <div v-html="htmlData">
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Event',
  metaInfo () {
    return {
      title: ''
    }
  },
  data () {
    return {
      htmlData: null
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let url = `https://api.liveabc.com/v1/promote_events/${this.$route.params.eventId}/page`
      axios.get(url)
        .then((response) => {
          this.htmlData = response.data.html
          console.log(response.data.html)
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
